module.exports = __webpack_public_path__ + "static/media/testimonials-5.72fb0443.jpg";